/**
 * Grid Component
 *
 * Abstraction layer over MUI Grid.
 */

import { GridProps, Grid as MuiGrid } from '@mui/material';
import React from 'react';

const Grid = React.forwardRef<any, any>((props, ref) => {
  return <MuiGrid ref={ref} {...props} />;
});

Grid.displayName = 'Grid';

export default Grid;
